import React from 'react';
import { Helmet } from 'react-helmet-async';
type SeoProps = {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  lang?: string;
  keywords?: string | string[];
};
const Seo: React.FC<SeoProps> = ({
  title = 'Vende tu propiedad con tarifa fija | MINGA',
  description = 'Vende inteligente con MINGA: un solo corredor (abiertos a canje), menos visitas gracias a filtros reales, sin comisión al comprador y proceso 100% digital. Tasación con 3 fuentes y marketing profesional.',
  url = 'https://somosminga.com/vender',
  image = 'https://somosminga.com/og/minga-vender.jpg',
  lang = 'es',
  keywords = 'vender propiedad, tarifa fija, corretaje, canje, fotos profesionales, tour virtual, planos, carpeta legal, Chile'
}) => {
  const keywordsString = Array.isArray(keywords) ? keywords.join(', ') : keywords;
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'MINGA',
    url: url,
    logo: image,
    sameAs: []
  };
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: url,
    name: 'MINGA',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${url}?q={search_term_string}`,
      'query-input': 'required name=search_term_string'
    }
  };
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Venta de propiedades con tarifa fija',
    areaServed: 'CL',
    provider: {
      '@type': 'Organization',
      name: 'MINGA'
    },
    offers: {
      '@type': 'Offer',
      price: '10000000',
      priceCurrency: 'CLP',
      eligibleRegion: 'CL',
      valueAddedTaxIncluded: true
    }
  };
  return <Helmet data-id="element-274">
      {/* HTML lang attribute */}
      <html lang={lang} data-id="element-275" />
      {/* Basic meta tags */}
      <meta charSet="utf-8" data-id="element-276" />
      <meta name="viewport" content="width=device-width, initial-scale=1" data-id="element-277" />
      <meta name="theme-color" content="#2563eb" data-id="element-278" />
      <meta name="language" content={lang} data-id="element-279" />
      <meta name="robots" content="index, follow" data-id="element-280" />
      <meta name="author" content="MINGA" data-id="element-281" />
      {/* Title and description */}
      <title data-id="element-282">{title}</title>
      <meta name="description" content={description} data-id="element-283" />
      <meta name="keywords" content={keywordsString} data-id="element-284" />
      {/* Canonical URL */}
      <link rel="canonical" href={url} data-id="element-285" />
      {/* Open Graph */}
      <meta property="og:type" content="website" data-id="element-286" />
      <meta property="og:site_name" content="MINGA" data-id="element-287" />
      <meta property="og:locale" content="es_LA" data-id="element-288" />
      <meta property="og:title" content={title} data-id="element-289" />
      <meta property="og:description" content={description} data-id="element-290" />
      <meta property="og:url" content={url} data-id="element-291" />
      <meta property="og:image" content={image} data-id="element-292" />
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-293" />
      <meta name="twitter:site" content="@minga" data-id="element-294" />
      <meta name="twitter:title" content={title} data-id="element-295" />
      <meta name="twitter:description" content={description} data-id="element-296" />
      <meta name="twitter:image" content={image} data-id="element-297" />
      {/* Smooth scroll style */}
      <style type="text/css" data-id="element-298">{`
        html {
          scroll-behavior: smooth;
        }
      `}</style>
      {/* JSON-LD structured data */}
      <script type="application/ld+json" data-id="element-299">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json" data-id="element-300">
        {JSON.stringify(websiteSchema)}
      </script>
      <script type="application/ld+json" data-id="element-301">
        {JSON.stringify(serviceSchema)}
      </script>
    </Helmet>;
};
export default Seo;